import IconLogoGlobalShapeLg from '@/assets/svg/dog-logo-text.svg?react';
import IconLogoShapeLg from '@/assets/svg/fox-logo-text.svg?react';
import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import { DOCS_SITE_EVENT } from '@/shared/constant/Analytics';
import type { OnlineType } from '@/shared/constant/OnlineType';
import type { UtmCampaign } from '@/shared/constant/utm';
import { gaReport } from '@/shared/util/analytics';
import { generateUrlWithUtm } from '@/shared/util/generateUrlWithUtm.client';
import { Link } from '@remix-run/react';
import { Tooltip } from 'aui';
import clsx from 'clsx';
import styles from './FooterSlogan.module.css';

export type FooterSloganProps = {
  className?: string;
  title: string;
  homeIndexUrl: string;
  utmCampaign: UtmCampaign;
  onlineType: OnlineType;
};

export function FooterSlogan(props: FooterSloganProps) {
  const { className, title, homeIndexUrl, utmCampaign, onlineType } = props;

  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);

  return (
    <Tooltip title={clientI18n('slogan')}>
      <div
        className={clsx(
          'inline-flex items-center text-base font-400 text-secondary',
          styles['footer-logo-wrapper'],
          className,
        )}
      >
        <Link
          to={homeIndexUrl}
          className={clsx(styles['footer-logo'], 'flex-shrink-0')}
          onClick={(e) => {
            gaReport(DOCS_SITE_EVENT.FOOTER_GOTO_HOME, { page_title: title });
            e.preventDefault();
            const url = generateUrlWithUtm(homeIndexUrl, utmCampaign, onlineType);
            window.open(url);
          }}
          aria-label="homepage link"
        >
          <span className="inline-flex items-center">
            <span className="mr-[-4px]">{clientI18n('built.with')}</span>
            {IS_GLOBAL ? (
              <IconLogoGlobalShapeLg className="h-[18px] w-[80px]" />
            ) : (
              <IconLogoShapeLg className="h-[18px] w-[80px]" />
            )}
          </span>
        </Link>
      </div>
    </Tooltip>
  );
}
